var render = function render(){var _vm=this,_c=_vm._self._c;return _c('SGPFormBotaoComponent',{staticClass:"botao-voltar",attrs:{"fab":"","text":"","small":"","color":"primary"},on:{"click":_vm.voltar}},[_c('SGPIconComponent',{attrs:{"icon":"mdi-arrow-left"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }